
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 10 10","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4.98.04a4.98 4.98 0 1 0 0 9.96 4.98 4.98 0 0 0 0-9.96zm-.068 1.826a.744.744 0 1 1 .001 1.488.744.744 0 0 1-.001-1.488zm1.163 6.308H3.886v-.887h.486v-2.58H4.33a.443.443 0 1 1 0-.886H5.59v3.466h.484v.887z","fill":"#8AC4AB","fill-rule":"evenodd"}})])
      }
    
      }
    